import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

export default function DeleteModal({ open, onClose, onDelete }) {
  return (
  <Dialog open={open} onClose={onClose} aria-labelledby="delete-dialog-title">
       <DialogTitle id="delete-dialog-title">Are you sure you want to delete this?</DialogTitle>
       <DialogActions>
         <Button type="button" onClick={onClose}>
           Cancel
         </Button>
         <LoadingButton type="button" onClick={onDelete}>
           Delete
         </LoadingButton>
       </DialogActions>
     </Dialog>
  );
}

DeleteModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
};
